<!--今日客户任务-->
<template>
  <article>
    <div ref="header">
      <div class="plarform-search">
        <a href="javascript:void(0);" class="search-icon" @click.stop="search"></a>
        <input v-model="mobile" type="text" class="search-number" placeholder="请输联系电话">
      </div>
      <div class="tab-service">
        <ul class="tab-service-detail">
          <li :class="{'on':time_interval===3}" @click="onShiftTap(3)"><a href="javascript:void(0);">逾期</a></li>
          <li :class="{'on':time_interval===1}" @click="onShiftTap(1)"><a href="javascript:void(0);">今日到期</a>
          </li>
          <li :class="{'on':time_interval===2}" @click="onShiftTap(2)"><a href="javascript:void(0);">3日内到期</a>
          </li>
          <li :class="{'on':time_interval===''}" @click="onShiftTap('')"><a href="javascript:void(0);">全部</a></li>
        </ul>
      </div>
    </div>

    <!-- height要算准确 -->
    <scroller
      lock-x scrollbar-y
      use-pullup
      ref="myScroller"
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      :height="scrollerHeight">
      <div class="mt-20">
        <group v-for="(item,index) in taskList" :key="index">
          <cell class="personal-info-detail">
            <p slot="after-title">姓名：{{item.customer_name}}<span class="label">{{item.intention_level}}级</span></p>
            <a slot="value" class="phone-icon-right" :href="`tel:${item.mobile}`"
               @click.stop="makeACall(item.customer_id,item.id,item.assignee_id)"></a>
          </cell>
          <cell class="personal-info-detail personal-info-value">
            <div slot="after-title" class="title-list">
              <p v-for="(v, index) in item.intention_cars" :key="index"><span class="car-name">{{v.car_model}}</span><span>-{{v.inner_color}}-{{v.outer_color}}</span>
              </p>
            </div>
            <span slot="value" class="info info2">已联系<span class="red">{{item.call_count}}</span>次</span>
            <p slot="after-title" class="info">预约到店：{{item.next_arrive_at}}</p>
            <p slot="after-title" class="info">下次致电：{{timeTransform(item.next_contact_at)}}</p>
            <p slot="after-title" class="info">最近联系：{{item.last_contact_at}}</p>
            <p slot="after-title" class="info">联系电话：{{item.mobile}}</p>
            <em class="icon-done" v-if="item.is_complete"></em>
          </cell>
          <cell class="personal-info-detail">
            <p slot="after-title">
              当前任务：第<span class="red">{{item.sequence}}</span>次，
              共<span class="red">{{item.total_task_count}}</span>次任务
              <span v-if="!item.is_complete && item.day_to_expire<0">
              ，已逾期<span class="red">{{Math.abs(item.day_to_expire)}}</span>天
            </span>
              <span v-else-if="item.day_to_expire>0">
              ，还有<span class="red">{{item.day_to_expire}}</span>天到期
            </span>
            </p>
          </cell>
        </group>
        <p class="tip-text1">共有{{totalCount}}条任务待跟进</p>
      </div>
    </scroller>
  </article>
</template>
<script>
import {
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import util from '../../../common/util'
import cache from '../../../common/cache'
import callMixins from '../../mixins/call.mixins'
import authApi from '../../../common/auth'

export default {
  mixins: [callMixins],
  components: {
    Scroller,
    Cell,
    Group
  },
  data () {
    return {
      // 客户跟进权限
      followCustomerAuth: false,
      authId: '',
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      mobile: '',
      totalCount: 0,
      totalPage: 1,
      item_per_page: 20,
      page: 1,
      time_interval: '',
      taskList: [],
      customerList: [],
      scrollerHeight: ''
    }
  },
  mounted () {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    this.$store.state.promiseAuth.then(auth => {
      let authList = auth.authList
      this.authId = auth.id
      this.followCustomerAuth = authList.includes(authApi.saleManage.sale_potential_customer_follow_up)
      if (this.followCustomerAuth) {
        this.getTasksList()
        this.getRecordAuth()
      } else {
        this.showToast('您尚未获得相关权限')
      }
    })
  },
  methods: {
    loadMore (done) {
      if (this.page < this.totalPage) {
        ++this.page
        this.$rest.saleManage.todayCustomerTaskTask({
          page: this.page,
          mobile: this.mobile,
          item_per_page: this.item_per_page,
          time_interval: this.time_interval
        }).then(res => {
          if (res.code === 0) {
            this.taskList.push(...res.data.tasks)
            this.totalCount = res.data.total
            this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
            done(100)
          }
        })
      } else {
        done()
      }
    },
    getTasksList () {
      this.$rest.saleManage.todayCustomerTaskTask({
        page: this.page,
        mobile: this.mobile,
        item_per_page: this.item_per_page,
        time_interval: this.time_interval
      }).then(res => {
        if (res.code === 0) {
          this.taskList = res.data.tasks
          this.totalCount = res.data.total
          this.totalPage = parseInt((parseInt(this.totalCount) + this.item_per_page - 1) / this.item_per_page)
          this.$nextTick(() => {
            if (this.$refs.myScroller) {
              this.$refs.myScroller.reset({
                top: 0
              })
            }
          })
        } else {
          this.showToast(res.message)
        }
      })
    },
    search () {
      if (!this.mobile) {
        this.showToast('请输入联系电话')
        return false
      } else if (!util.regexpMap.regexp_mobile.test(this.mobile)) {
        this.showToast('请输入正确的号码')
        return false
      }
      this.page = 1
      this.totalPage = 1
      this.taskList = []
      this.getTasksList()
    },
    onShiftTap (timeInterval) {
      if (this.time_interval === timeInterval) return
      this.time_interval = timeInterval
      this.page = 1
      this.taskList = []
      this.getTasksList()
    },
    timeTransform (str) {
      if (!str) return ''
      let date = new Date(str.replace(/-/g, '/'))
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + month + '-' + day
    },
    makeACall (customerId, id, assigneeId) {
      if (this.authId === assigneeId) {
        cache.clearSessionData('addCustomerRecordLocalData')
        this.initCall({
          interval: 1000,
          threshold: 0,
          openLog: false,
          complete: (startTime, endTime) => {
            this.$router.push({
              path: '/salemanage/staff/addcustomerrecord/' + customerId,
              query: { call_duration: endTime - startTime, customer_task_id: id }
            })
          }
        })
      }
    },
    toArchives (id) {
      cache.clearSessionData('customerArchivesLocalData')
      this.$router.push({ path: '/salemanage/staff/customerarchives', query: { id: id } })
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
